<template>
  <div id="app">
    <main-header v-if="$store.getters.isAuthenticated"></main-header>
    <router-view />
    <notificator />
    <main-footer v-if="$store.getters.isAuthenticated && !$store.state.hideFooter"></main-footer>
  </div>
</template>

<script>
import { MainFooter, MainHeader, Notificator } from "@/components"

export default {
  name: "App",
  components: {
    MainFooter,
    MainHeader,
    Notificator,
  },
}
</script>

<style lang="scss">
@import "./assets/scss/app.scss";
</style>
